<template>
    <transition name="modal">
        <div class="modal-mask" v-if="show">
            <div class="p-6 h-full max-h-screen overflow-y-auto overflow-x-hidden">
                <div class="modal-container sm:mx-auto shadow rounded-lg p-6"
                    :class="[width, bg, customClass]">
                    <div v-if="hasHeader" class="mb-6 flex items-center justify-between">
                        <h2 class="font-thin tracking-widest uppercase flex-1">
                            <slot name="header"></slot>
                        </h2>
                        <close-icon 
                            @click.native.stop="close" 
                            class="cursor-pointer text-gray-600 ml-5"
                            title="Close"
                            v-if="closeable"
                        />
                    </div>
                    <div class="modal-body" style="height: calc(100% - 48px)">
                        <slot name="body"></slot>
                    </div>
                    <div class="modal-footer text-right mt-6"
                        v-if="hasFooter">
                        <slot name="footer">
                            <button class="btn-white shadow px-3 py-2 border rounded-sm text-grey-darker hover:text-grey-darkest hover:border-grey-dark"
                                @click="close">Close</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: true
            },
            type: {
                type: String,
                default: 'modal'
            },
            notification: {
                type: Object,
                default () {
                    return {}
                }
            },
            width: {
                type: String,
                default: 'sm:w-64'
            },
            bg: {
                type: String,
                default: 'bg-white'
            },
            customClass: {
                type: String,
                default: '',
            },
            hasHeader: {
                type: Boolean,
                default: true,
            },
            hasFooter: {
                type: Boolean,
                default: false
            },
            closeable: {
                type: Boolean,
                default: true
            }
        },
        components: {
            CloseIcon: () => import(/* webpackChunkName: "close-icon" */ '@/icons/Close.vue')
        },
        data() {
            return {
                body: document.getElementsByTagName('body')[0]
            }
        },
        watch: {
            show(show) {
                setTimeout(() => {
                    if (document.getElementsByClassName('modal-mask').length == 0) {
                        this.body.classList.remove('modal-open')
                        document.removeEventListener('keyup', this.keyupListener)
                    }
                }, 500)

                if (show) {
                    this.body.classList.add('modal-open')
                    document.addEventListener('keyup', this.keyupListener)
                } else {
                    this.$emit('close')
                }
            }
        },
        methods: {
            keyupListener(e) {
                if (e.keyCode === 27) {
                    this.$emit('update:show', false)
                    this.$emit('close')
                }

                if (e.keyCode === 13) {
                    this.$emit('keyupEnter')
                }
            },
            close() {
                this.$emit('update:show', false)
                this.$emit('close')
            }
        }
    }
</script>
<style lang="scss" scoped>    
    .modal-mask {
        position: fixed;
        z-index: 1031;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }

    .modal-container {
        transition: all .3s ease;
    }
    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>